<template>
    <MapViewer
        class="o-terminal-map-controller terminal-map-controller"
        :map-data="getMvData"
        :active-view="activeView"
        :is-reactive="isMapViewerReactivity"
        @ready="onMapReady"
        ref="mapViewer"
    >
        <OMapGuideViews v-if="activePath" @changeView="setActiveView"/>
    </MapViewer>
</template>

<script>
import {mapGetters, mapState} from 'vuex';
import OMapGuideViews from "../o-map-guide-views/o-map-guide-views";
import MapViewer from "../../../shared/components/map-viewer/map-viewer";
import {LOADING_PROGRESS} from "@/utils/constants/bus-events-constants";

export default {
    name: "OTerminalMapController",
    components: {
        MapViewer,
        OMapGuideViews,
    },
    data() {
        return {
            activeView: 'OutdoorView',
            loadingInterval: null,
            progress: 40,
        }
    },
    computed: {
        ...mapState({
            objects: state => state.objects,
            activePath: state => state.activePath
        }),
        ...mapGetters([
            'getMvData',
            'getTerminalId',
            'getMapConfigProp'
        ]),
        componentParams() {
            return this.getMapConfigProp('components.OTerminalMapController.params') || {};
        },
        isMapViewerReactivity() {
            return !!this.componentParams.is_map_viewer_reactivity;
        }
    },
    methods: {
        onMapReady() {
            this.requestUnitDistances()
        },
        requestUnitDistances(){
            const distancesUpdatedAt = localStorage?.getItem('objects_distances_updated_at');
            const distances =  JSON.parse(localStorage?.getItem('objects_distances') || '{}');
            const terminalId = localStorage?.getItem('curren_terminal_id');
            const isExpired = Date.now() - distancesUpdatedAt > 1000 * 60 * 60 * 24;
            
            const isTerminalMatch = terminalId == this.getTerminalId;

            if(!isExpired && this.areObjectsUnchanged() && isTerminalMatch && !_.isEmpty(distances)){
                this.$store.commit("setObjectDistances", distances);
                this.$store.commit('setMapLoading', false);
            }
            else{
                clearInterval(this.loadingInterval);
                this.loadingInterval = setInterval( () => this.progress < 100 && this.$bus.$emit(LOADING_PROGRESS, this.progress+=3), 3000);
                const request = {
                    from: { unit: this.getMvData.terminalUnitName },
                    to: this.getObjectUnits()
                };
                this.$refs.mapViewer.getUnitDistances(request);
            }
        },
        setUnitDistances(distances){
            this.$store.commit("setObjectDistances", distances);
            try {
                localStorage?.setItem('objects_distances',  JSON.stringify(distances));
                localStorage?.setItem('objects_count', this.getMvData.objects.length);
                localStorage?.setItem('curren_terminal_id', this.getTerminalId);
                localStorage?.setItem('objects_distances_updated_at', Date.now());
            }catch (e){
                console.error(e);
            }
            this.$store.commit('setMapLoading', false);
            this.$store.commit('setloading', false);
            clearInterval(this.loadingInterval);
        },
        setActiveView(activeView){
            this.activeView = activeView
        },
        areObjectsUnchanged() {
            const storageUnitsWithDistace = JSON.parse(localStorage?.getItem('objects_distances') || '{}');
            const objectsUnits = this.getObjectUnits();
            if(storageUnitsWithDistace.length !== objectsUnits.length) {
                return false
            }

            let isObjectsUnitsEqual = true

            objectsUnits.forEach(({unit}) => {
                if(!storageUnitsWithDistace.some(obj => obj.unit === unit)) {
                    isObjectsUnitsEqual = false
                }
            })
            return isObjectsUnitsEqual
        },
        getObjectUnits() {
            const calcForTypes = ['tenant', 'service'];

            return Object.values(
                this.getMvData.objects.reduce((acc, o) => {
                    if(calcForTypes.includes(o.type))
                        acc[o.unit.name] = { unit: o.unit.name };
                    return acc
                }, {} )
            )
        }
    },
    watch:{
        activePath(){
            this.activeView = this.activePath ? 'GuideView' : "OutdoorView";
        },
        getTerminalId() {
            this.$store.commit('setloading', true);
            this.requestUnitDistances();
        }
    },
    mounted() {
        this.$bus.$on("ui:unitDistances", this.setUnitDistances);
    },
    beforeDestroy() {
        this.$bus.$off("ui:unitDistances", this.setUnitDistances);
    }
}
</script>

<style lang="scss">
@import "terminal-map-controller";
</style>
